import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import { Row,  Table } from 'reactstrap';

import { useNavigate } from 'react-router-dom';
import { BiEditAlt, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom'
import { BiLeftArrowAlt } from 'react-icons/bi';
import useAuth from '../../hooks/useAuth';

const FooterView = () => {
    const { auth } = useAuth();

    const [modal, openModal] = useState(false);
    const toggle = () => openModal(!modal);
    const [footer, setFooter] = useState([]);
    const navigate = useNavigate();

    const handleDelete =  async (event, id) => {
        event.preventDefault();
        try {
            const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/footers/delete-footer/${id}`,  {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            });
            const res1 = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/footers/find-all`);
            setFooter(res1.data);
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
        } catch (error) {
            error.response.data.message ? toast.error(error.response.data.message, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
                }) :  toast.error(error.response.data.error, {
                  className: "error-toast",
                  position: toast.POSITION.BOTTOM_RIGHT,
                  autoClose: 3000
              })
         }
    }
        
   
    useEffect(() => {
      const source = axios.CancelToken.source();
      const getfooter = async () => {
      try {
          const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/footers/find-all`, {
              cancelToken: source.token
          });
          setFooter(res.data);
         
      } catch (error) {
              if (axios.isCancel(error)) {
                  console.log('cancelled');
              } else {
                  throw error;
              }
          }
      }
      
      getfooter();
      return () => {
          source.cancel();
      };
  },[])
    return (
        <div className="container">
          <Row sm="12">
            <h5 className="sec-header">Footer Information</h5>
        </Row> 
        <Row>
            <Table responsive hover>
                <thead>
                <tr>
                    <th>#</th>
                    <th>Address</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Locations</th>
                    <th>Focus Area</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                    footer.map(footer => (
                      <tr key={footer.id}>
                            <td>{footer.id}</td>
                            <td style={{wordBreak: "break-all"}}>{footer.footerAddress}</td>
                            <td style={{wordBreak: "break-all"}}>{footer.footerEmail}</td>
                            <td>{footer.footerPhone}</td>
                            <td>{footer.footerLocations}</td>
                            <td>{footer.focusArea.join(",")}</td>
                            <td>
                                <BiEditAlt className="edit_icon icon_hover" onClick={() => navigate(`/footer/edit/${footer.id}`)} size={30}/> 
                                {/* <BiTrash className="delete_icon icon_hover" onClick={(event) => handleDelete(event, footer.id)} size={20} />      */}
                            </td>
                    </tr>
                  ))  
                }
                                
                </tbody>
            </Table>
     </Row>
     {/* {
        footer && <Row sm="12" className="mt-4 text-center">
          <Link to={"/community/feature/add"} className="go_back" >
            <BiLeftArrowAlt size={30} /> Go to Add Community Feature          </Link>
      </Row> 
         } */}
        </div>
    )
   
}

export default FooterView;